import { markUiObject as __markUi } from '@/i18n/display'
import sysRequest from '@/api/sys'

// 2026-09-03：客户端统一读取平台维护配置。
// 2026-09-08：缺失或非法配置必须由调用方保留未确认状态，不能默认开放业务。
export interface SystemMaintenanceConfig {
  // 2026-09-06：测试资格与服务端本轮维护标识一致时才有效。
  updatedAt: string
  enabled: boolean
  title: string
  message: string
}

export const DEFAULT_MAINTENANCE_CONFIG: SystemMaintenanceConfig = __markUi({
  updatedAt: '',
  enabled: false,
  title: '系统维护中',
  message: '系统正在升级维护，为避免操作期间产生数据异常，暂时停止访问。请稍后再试，感谢您的理解。'
}, {"title":"系统维护中","message":"系统正在升级维护，为避免操作期间产生数据异常，暂时停止访问。请稍后再试，感谢您的理解。"})

const isPlainObject = (value: unknown): value is Record<string, unknown> =>
  Boolean(value) && typeof value === 'object' && !Array.isArray(value)

const parseSettings = (raw: unknown): Record<string, unknown> => {
  if (isPlainObject(raw)) return raw
  if (typeof raw !== 'string' || !raw.trim()) return {}
  try {
    const parsed = JSON.parse(raw)
    return isPlainObject(parsed) ? parsed : {}
  } catch (_error) {
    return {}
  }
}

export const normalizeMaintenanceConfig = (raw: unknown): SystemMaintenanceConfig => {
  const source = isPlainObject(raw) ? raw : {}
  return {
    updatedAt: source.updatedAt == null ? '' : String(source.updatedAt),
    enabled: source.enabled === true,
    title: typeof source.title === 'string' && source.title.trim()
      ? source.title.trim().slice(0, 40)
      : DEFAULT_MAINTENANCE_CONFIG.title,
    message: typeof source.message === 'string' && source.message.trim()
      ? source.message.trim().slice(0, 500)
      : DEFAULT_MAINTENANCE_CONFIG.message
  }
}

export const loadPlatformMaintenance = async (): Promise<SystemMaintenanceConfig> => {
  const response: any = await sysRequest.getPublicPlatformInfo()
  const settings = parseSettings(response?.data?.orgInfo?.settings)
  // 2026-09-08：仅接受明确布尔开关；缺失、非法 JSON 或错误类型都不能解释为关闭维护。
  const maintenance = settings.systemMaintenance
  if (!isPlainObject(maintenance) || typeof maintenance.enabled !== 'boolean') {
    throw new Error('暂时无法确认系统状态，请稍后重试。')
  }
  return normalizeMaintenanceConfig(maintenance)
}
